import React from 'react';

import { IMenuItem, IMenuItems } from 'components/MenuItems/interface';
import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import Billet from 'components/MenuItems/Billet';
import TrackingOrder from 'components/MenuItems/TrackingOrder';
import Invoice from 'components/MenuItems/Invoice';
import XmlInvoice from 'components/MenuItems/XmlInvoice';
import Tracking from 'components/MenuItems/Tracking';

import { useCustomEvent } from 'components/ApplicationInsights';
import { eventName } from 'components/ApplicationInsights/eventNames';

import './styles.scss';

const MenuItem: React.FC<IMenuItem> = (props) => {
  const componentName = `Menu Cockpit Fornecedor`;
  const trackMenuClick = useCustomEvent(componentName, eventName.COCKPIT_FORNECEDOR);
  const { icon, title, subtitle, onClick, trackName, disabled = false } = props;

  async function clickMenu() {
    if (trackName) {
      trackMenuClick({ item: trackName });
    }

    if (onClick) {
      onClick();
    }
  }

  return (
    <button
      className="d-flex menu-item first flex-column align-center justify-center pb-2 pt-3 bg-white shadow-1"
      onClick={clickMenu}
      disabled={disabled}
    >
      {icon && <img src={icon} alt="" />}
      <Column>
        <Text
          size={13}
          className="mt-2 text-center color-blue-gray text-wrap font-bold"
        >
          {title}
        </Text>
        <Text
          size={13}
          className="text-center color-blue-gray text-wrap font-bold"
        >
          {subtitle}
        </Text>
      </Column>
    </button>
  );
};

const MenuItemsSupplier: React.FC<IMenuItems> = () => {
  return (
    <>
      <Row className="menu-main-grid mt-3">
        <Billet itemComponent={MenuItem} />
        <TrackingOrder itemComponent={MenuItem} />
        <Invoice itemComponent={MenuItem} />
        <XmlInvoice itemComponent={MenuItem} />
        <Tracking itemComponent={MenuItem} />      
      </Row>
    </>
  );
};

export default MenuItemsSupplier;
